module.exports = __webpack_public_path__ + "static/media/img8.c9cd8c1e.jpeg";